// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 240 ? "c36f3faa" : chunkId) + "." + {"240":"c355c86f694be06d","398":"152db60495672e5b"}[chunkId] + ".js";
};